import { giphyIndigo, giphyPurple } from '@giphy/js-brand'
import React, { SyntheticEvent, useEffect, useState } from 'react'
import { useKeyPress } from 'react-use'
import styled from 'styled-components'
import { BORDER_RADIUS_SMALL } from '../../../../../constants'
import CreationToolUploadField from '../../../../../types/upload-field'
import { UtilityButton } from '../../../../buttons'
import { CreationToolUploadSource } from '../../../types'

const FIELD = CreationToolUploadField.VideoTitle

const Container = styled.div`
    display: flex;
    width: 100%;

    input[type='text'] {
        border-top-left-radius: ${BORDER_RADIUS_SMALL}px;
        border-bottom-left-radius: ${BORDER_RADIUS_SMALL}px;
        height: 36px;
        margin: 0;
        width: 100%;
    }
`

const SaveButton = styled(UtilityButton)`
    background: linear-gradient(45deg, ${giphyIndigo}, ${giphyPurple});
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    flex-shrink: 0;
    font-size: 15px;
    padding: 0 20px;
`

type Props = {
    source: CreationToolUploadSource
    onSave: (title: string) => void
}

const CreationUploadItemLabelInput = ({ source, onSave }: Props) => {
    const { title = '' } = source
    const [inputValue, setInputValue] = useState<string>(title)
    const [isEscPressed] = useKeyPress((event: KeyboardEvent) => event.key === 'Esc' || event.key === 'Escape')
    const [isEnterPressed] = useKeyPress((event: KeyboardEvent) => event.key === 'Enter')
    const placeholder = CreationToolUploadField.description(FIELD)
    const maxLength = CreationToolUploadField.maxCharacterCount(FIELD)

    useEffect(() => {
        if (isEnterPressed && inputValue) {
            onSave(inputValue)
        } else if (isEscPressed) {
            onSave(title)
        }
    }, [isEscPressed, isEnterPressed])

    const onInputChange = (e: SyntheticEvent<HTMLInputElement, Event>) => {
        setInputValue(e.currentTarget.value || '')
    }

    return (
        <Container>
            <input
                {...{
                    autoFocus: true,
                    value: inputValue,
                    type: 'text',
                    placeholder,
                    maxLength: maxLength || undefined,
                    onChange: onInputChange,
                }}
            />
            <SaveButton disabled={!inputValue} onClick={() => onSave(inputValue)}>
                Save
            </SaveButton>
        </Container>
    )
}

export default CreationUploadItemLabelInput
